import { supabase } from "../lib/supabase";

const STORAGE_KEY = "almoune_message_templates";

export const DEFAULT_RETARD_MESSAGE = "Bonjour,\n\nMalheureusement, un article que vous avez commandé est actuellement en rupture de stock. Pour cette raison, il est possible que la livraison de votre commande soit légèrement retardée.\nNous vous prions de bien vouloir accepter nos excuses. Nous faisons tout notre possible pour remédier à cette situation.\n\nCordialement,";

const readCache = () => {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]"); }
  catch { return []; }
};

const writeCache = (data) => {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch {}
};

const normalize = (row) => ({
  id: Number(row.id) || nextId(readCache()),
  nom: row.nom || row.name || "",
  message: row.message || "",
  createdAt: row.created_at || row.createdAt || new Date().toISOString(),
});

const nextId = (list) =>
  list.reduce((max, r) => Math.max(max, Number(r.id) || 0), 0) + 1;

const ensureDefaultTemplate = async (rows) => {
  if (rows.length > 0) return rows;
  const seeded = [{ id: 1, nom: "Retard stock", message: DEFAULT_RETARD_MESSAGE }];
  writeCache(seeded);
  try {
    if (supabase) {
      await supabase
        .from("message_templates")
        .upsert({ id: 1, nom: "Retard stock", message: DEFAULT_RETARD_MESSAGE }, { onConflict: "id" });
    }
  } catch {}
  return seeded;
};

export const loadMessageTemplates = async () => {
  try {
    if (supabase) {
      const { data, error } = await supabase
        .from("message_templates")
        .select("*")
        .order("id", { ascending: true });
      if (!error) {
        const rows = (data || []).map(normalize);
        const seeded = await ensureDefaultTemplate(rows);
        writeCache(seeded);
        return seeded;
      }
    }
  } catch {}
  return ensureDefaultTemplate(readCache());
};

export const saveMessageTemplate = async (template) => {
  const normalized = {
    id: Number(template.id) || nextId(readCache()),
    nom: template.nom || "",
    message: template.message || "",
  };
  const cache = readCache();
  const idx = cache.findIndex((r) => Number(r.id) === normalized.id);
  if (idx >= 0) cache[idx] = { ...cache[idx], ...normalized };
  else cache.push(normalized);
  writeCache(cache);
  try {
    if (supabase) {
      const { error } = await supabase
        .from("message_templates")
        .upsert(normalized, { onConflict: "id" });
      if (error) throw error;
    }
  } catch {}
  return normalize(normalized);
};

export const deleteMessageTemplate = async (id) => {
  const cache = readCache().filter((r) => Number(r.id) !== Number(id));
  writeCache(cache);
  try {
    if (supabase) {
      const { error } = await supabase
        .from("message_templates")
        .delete()
        .eq("id", Number(id));
      if (error) throw error;
    }
  } catch {}
};
